"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowConfigs = void 0;
const react_1 = __importDefault(require("react"));
const PunchWorkflowTypes_1 = require("./PunchWorkflowTypes");
const Steps_1 = require("./Steps");
const selectDateStepConfig = {
    renderStepComp: () => react_1.default.createElement(Steps_1.SelectDate, null)
};
const selectActionStepConfig = {
    renderStepComp: () => react_1.default.createElement(Steps_1.SelectAction, null)
};
const selectPunchStepConfig = {
    renderStepComp: () => react_1.default.createElement(Steps_1.SelectPunch, null)
};
const editPunchStepConfig = {
    renderStepComp: () => react_1.default.createElement(Steps_1.EditPunch, null)
};
const reviewStepConfig = {
    renderStepComp: () => react_1.default.createElement(Steps_1.Review, null)
};
exports.workflowConfigs = {
    default: {
        steps: [
            selectDateStepConfig,
            selectActionStepConfig,
            selectPunchStepConfig,
            editPunchStepConfig,
            reviewStepConfig
        ]
    },
    [PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.ADD]: {
        steps: [
            selectDateStepConfig,
            selectActionStepConfig,
            editPunchStepConfig,
            reviewStepConfig
        ]
    },
    [PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT]: {
        steps: [
            selectDateStepConfig,
            selectActionStepConfig,
            selectPunchStepConfig,
            editPunchStepConfig,
            reviewStepConfig
        ]
    },
    [PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.DELETE]: {
        steps: [
            selectDateStepConfig,
            selectActionStepConfig,
            selectPunchStepConfig,
            reviewStepConfig
        ]
    }
};
